var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12 col-md-4 mb-3 card-wrap" }, [
    _c("div", { staticClass: "card h-100 card-news" }, [
      _vm.featured_img
        ? _c(
            "div",
            { staticClass: "aspect-ratio-box aspect-ratio-box-16x9 mb-2" },
            [
              _c("img", {
                staticClass:
                  "aspect-ratio-box-inner object-fit-contain object-position-center-center",
                attrs: { src: _vm.featured_img, "aria-label": _vm.alt_text },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card-body px-0 pt-0" }, [
        _vm.type
          ? _c("span", { staticClass: "btn btn-dark" }, [
              _vm._v(_vm._s(_vm.type)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1" }, [_vm._v(_vm._s(_vm.publish_date))]),
        _vm._v(" "),
        _c("h6", {
          staticClass: "card-title pt-2 mb-0",
          domProps: { innerHTML: _vm._s(_vm.title) },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "card-text py-2" }, [
          _vm._v(_vm._s(_vm.excerpt)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-link mt-2" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary px-3",
              attrs: { href: _vm.permalink },
            },
            [_vm._v("Read Full Article")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }